import React, { useState } from "react";

// ASSETS
import { IconButtonAtomProps } from "./IconButtonAtomModel";

// STYLES
import {
  IconWrapper,
  IconImage,
  IconButtonAtomContainer,
  HoverText,
  IconWrapperDesktop,
} from "./IconButtonAtomStyled";

// LIBRARIES
import { useMediaQuery } from "react-responsive";
// MISC
import { TextType } from "../CustomText/CustomTextModel";
// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "../CustomText/CustomText";

const IconButtonAtom: React.FC<IconButtonAtomProps> = (props) => {
  // PROPERTIES
  const {
    icon,
    iconHovered,
    isSelected = false,
    onClick,
    hoverText,
    desktop = true,
    style,
    hoverStyle
  } = props;
  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const isMobile = useMediaQuery({ maxWidth: 1280 });
  // STATE CONSTANTS

  const [isHovered, setIsHovered] = useState(false);
  const iconToUse = isHovered ? iconHovered : icon;

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <IconButtonAtomContainer tabIndex={0}>
      {desktop ? (
        <IconWrapperDesktop
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          isSelected={isSelected}
          onClick={onClick}
          biggerCursor={biggerCursor}
        >
          <IconImage 
            src={iconToUse} 
            alt="icon" 
            style={{
              ...style,
              ...(isHovered && hoverStyle)
            }} 
          />
          {!isMobile && (
            <HoverText isMobile={isMobile}>
              <CustomText text={hoverText} type={TextType.H5} />
            </HoverText>
          )}
        </IconWrapperDesktop>
      ) : (
        <IconWrapper
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          isSelected={isSelected}
          onClick={onClick}
          biggerCursor={biggerCursor}
        >
          <IconImage 
            src={iconToUse} 
            alt="icon" 
            style={{
              ...style,
              ...(isHovered && hoverStyle)
            }} 
          />
          {!isMobile && (
            <HoverText isMobile={isMobile}>
              <CustomText text={hoverText} type={TextType.H5} />
            </HoverText>
          )}
        </IconWrapper>
      )}
    </IconButtonAtomContainer>
  );
};

export default IconButtonAtom;
